<div class="container-fluid p-3">
  <mat-card>
    <mat-card-header class="pb-0">
      <mat-card-title>{{ isEditing ? 'Editar' : 'Crear' }} Agrupación de Novedades</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <form [formGroup]="agrupacionForm" (ngSubmit)="onSubmit()">
        <div class="row g-3 align-items-center">
          <div class="col-12 col-md-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Cód. Agrupación</mat-label>
              <input matInput formControlName="codigoagrupacion" 
                [readonly]="isEditing" 
                [matTooltip]="isEditing ? 'No se puede modificar el código de agrupación en modo edición' : ''"
                [matTooltipPosition]="'above'"
                (input)="onCodigoAgrupacionInput($event)">
            </mat-form-field>
          </div>
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Tipos de Novedad</mat-label>
              <input matInput [formControl]="tipoNovedadCtrl" [matAutocomplete]="autoTipoNovedad"
                (click)="mostrarListaTiposNovedad()" [placeholder]="getTipoNovedadPlaceholder()" class="selected-codes"
                style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
              <button type="button" mat-icon-button matSuffix (click)="mostrarListaTiposNovedad()">
                <mat-icon>arrow_drop_down</mat-icon>
              </button>

              <mat-autocomplete #autoTipoNovedad="matAutocomplete" [displayWith]="displayTipoNovedad">
                <mat-option *ngFor="let tipo of tiposNovedadFiltrados | async" [value]="tipo">
                  <mat-checkbox [checked]="isTipoNovedadSeleccionado(tipo)"
                    (click)="toggleSeleccionTipoNovedad(tipo, $event)">
                    {{tipo.descripcion}}
                  </mat-checkbox>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
        <div class="d-flex gap-2 mt-3 justify-content-end">
          <button mat-flat-button color="primary" type="submit"
            [disabled]="!agrupacionForm.valid || (!isEditing && tiposNovedadSeleccionados.length === 0)" class="btn btn-primary">
            {{isEditing ? 'Actualizar' : 'Guardar'}}
          </button>
          <button mat-flat-button type="button" (click)="cancelarEdicion()" *ngIf="isEditing" class="btn btn-secondary">
            Cancelar
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card class="mt-3">
    <mat-card-header class="pb-0">
      <mat-card-title>Lista de Agrupaciones</mat-card-title>
    </mat-card-header>


    <mat-card-content class="pt-3">
      <!-- Barra de búsqueda -->
      <div class="row mb-5">
        <div class="col-md-5 col-sm-12 mb-2 mb-sm-0">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Buscar</mat-label>
            <input matInput [formControl]="searchControl"
              placeholder="Buscar por código de agrupación o tipo de novedad...">
            <mat-icon matSuffix class="text-dark">search</mat-icon>
          </mat-form-field>
        </div>
      </div>

      <!-- Grupos de Agrupaciones -->
      <div class="agrupaciones-container">
        <mat-accordion class="w-100">
          <mat-expansion-panel *ngFor="let grupo of gruposAgrupaciones"
            [expanded]="expandedGroup === grupo.codigoagrupacion" (opened)="toggleGrupo(grupo.codigoagrupacion)"
            class="w-100">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Código de Agrupación: {{grupo.codigoagrupacion}}
              </mat-panel-title>
              <mat-panel-description class="d-flex justify-content-end align-items-center">
                <button mat-icon-button class="text-dark"
                  (click)="$event.stopPropagation(); editarAgrupacionCompleta(grupo)" matTooltip="Editar Grupo">
                  <mat-icon>edit</mat-icon>
                </button>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <!-- Tabla de novedades del grupo -->
            <table mat-table [dataSource]="grupo.novedades" class="w-100">
              <ng-container matColumnDef="codigonovedad">
                <th mat-header-cell *matHeaderCellDef>Tipo de Novedad</th>
                <td mat-cell *matCellDef="let element">
                  {{getTipoNovedadDescripcion(element.codigonovedad)}}
                </td>
              </ng-container>

              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element">ACTIVO</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </mat-card-content>
  </mat-card>
</div>